import React, { useState, useEffect } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, TextField, MenuItem, Select, FormControl, InputLabel,
  Grid, Typography, Divider, CircularProgress, Alert,
} from '@mui/material';
import { Edit } from '@mui/icons-material';

export const EditGameEntryDialog = ({ open, onClose, gameEntry, stage, event, onSave }) => {
  const [entity1Id, setEntity1Id] = useState('');
  const [entity2Id, setEntity2Id] = useState('');
  const [gameId, setGameId] = useState('');
  const [position, setPosition] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const participants = event?.entitiesParticipants || [];
  const games = event?.games || [];

  useEffect(() => {
    if (gameEntry) {
      setEntity1Id(gameEntry.entity1Id?._id || gameEntry.entity1Id || '');
      setEntity2Id(gameEntry.entity2Id?._id || gameEntry.entity2Id || '');
      setGameId(gameEntry.gameId?._id || gameEntry.gameId || '');
      setPosition(gameEntry.position ?? 0);
    }
    setError('');
  }, [gameEntry, open]);

  const handleSave = async () => {
    setLoading(true); setError('');
    try {
      await onSave({
        entity1Id: entity1Id || null,
        entity2Id: entity2Id || null,
        gameId: gameId || null,
        position: Number(position),
      });
      onClose();
    } catch (e) {
      setError(e?.response?.data?.message || 'Failed to update');
    } finally {
      setLoading(false);
    }
  };

 return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: 3 } }}>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Edit color="primary" />
        <Typography fontWeight="bold">Modifier le match — {stage?.title}</Typography>
      </DialogTitle>
      <Divider />
      <DialogContent sx={{ pt: 2 }}>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth size="small">
              <InputLabel>Équipe 1</InputLabel>
              <Select value={entity1Id} label="Équipe 1" onChange={e => setEntity1Id(e.target.value)}>
                <MenuItem value=""><em>À définir</em></MenuItem>
                {participants.map(p => {
                  const id = p?._id || p; const name = p?.name || id;
                  return <MenuItem key={id} value={id}>{name}</MenuItem>;
                })}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth size="small">
              <InputLabel>Équipe 2</InputLabel>
              <Select value={entity2Id} label="Équipe 2" onChange={e => setEntity2Id(e.target.value)}>
                <MenuItem value=""><em>À définir</em></MenuItem>
                {participants.map(p => {
                  const id = p?._id || p; const name = p?.name || id;
                  return <MenuItem key={id} value={id}>{name}</MenuItem>;
                })}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={8}>
            <FormControl fullWidth size="small">
              <InputLabel>Lier à un enregistrement de match (optionnel)</InputLabel>
              <Select value={gameId} label="Lier à un enregistrement de match (optionnel)" onChange={e => setGameId(e.target.value)}>
                <MenuItem value=""><em>Aucun</em></MenuItem>
                {games.map(g => {
                  const id = g?._id || g;
                  const e1 = g?.entity1?.name || '?';
                  const e2 = g?.entity2?.name || '?';
                  return <MenuItem key={id} value={id}>{e1} vs {e2}</MenuItem>;
                })}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField fullWidth size="small" label="Position" type="number"
              value={position} onChange={e => setPosition(e.target.value)} />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions sx={{ px: 3, py: 1.5 }}>
        <Button onClick={onClose} variant="outlined">Annuler</Button>
        <Button onClick={handleSave} variant="contained" disabled={loading}
          startIcon={loading ? <CircularProgress size={16} /> : <Edit />}>
          Enregistrer les modifications
        </Button>
      </DialogActions>
    </Dialog>
  );
};
